<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">
            <b-row class="justify-content-md-center">
              <b-col cols="12" md="12" class="text-center">
                <span><b>New Admin Addition</b></span>
              </b-col>
            </b-row>
          </template>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="11">
              <b-row>
                <b-col cols="12" md="5">
                  <b-row>
                    <b-col cols="12" md="4">
                      <span class="item_title">Email *</span>
                    </b-col>
                    <b-col cols="12" md="8">
                      <div :class="{ error: validation.hasError('email') }">
                        <b-form-group label="">
                          <b-form-input
                            v-model="email"
                            type="text"
                            id="email"
                            placeholder="Email"
                          ></b-form-input>
                          <template
                            slot="description"
                            v-if="validation.firstError('email')"
                          >
                            <span style="color: red">{{
                              validation.firstError("email")
                            }}</span>
                          </template>
                        </b-form-group>
                      </div>
                    </b-col>
                    <b-col cols="12" md="4">
                      <span class="item_title">Username *</span>
                    </b-col>
                    <b-col cols="12" md="8">
                      <div :class="{ error: validation.hasError('username') }">
                        <b-form-group label="">
                          <b-form-input
                            v-model="username"
                            type="text"
                            id="username"
                            placeholder="Username"
                          ></b-form-input>
                          <template
                            slot="description"
                            v-if="validation.firstError('username')"
                          >
                            <span style="color: red">{{
                              validation.firstError("username")
                            }}</span>
                          </template>
                        </b-form-group>
                      </div>
                    </b-col>
                    <b-col cols="12" md="4">
                      <span class="item_title">Password *</span>
                    </b-col>
                    <b-col cols="12" md="8">
                      <div :class="{ error: validation.hasError('password') }">
                        <b-form-group label="">
                          <b-form-input
                            v-model="password"
                            type="text"
                            id="password"
                            placeholder="Password"
                          ></b-form-input>
                          <template
                            slot="description"
                            v-if="validation.firstError('password')"
                          >
                            <span style="color: red">{{
                              validation.firstError("password")
                            }}</span>
                          </template>
                        </b-form-group>
                      </div>
                    </b-col>
                    <b-col cols="12" md="4">
                      <span class="item_title">Phone Number *</span>
                    </b-col>
                    <b-col cols="2">
                      <div :class="{ error: validation.hasError('phonePrefix') }">
                        <b-form-group label="">
                          <b-form-input
                            v-model="phonePrefix"
                            type="text"
                            id="prefix"
                            placeholder="Prefix"
                          ></b-form-input>
                          <template
                            slot="description"
                            v-if="validation.firstError('phonePrefix')"
                          >
                            <span style="color: red">{{
                              validation.firstError("phonePrefix")
                            }}</span>
                          </template>
                        </b-form-group>
                      </div>
                    </b-col>
                    <b-col cols="12" md="6">
                      <div :class="{ error: validation.hasError('phone') }">
                        <b-form-group label="">
                          <b-form-input
                            v-model="phone"
                            type="text"
                            id="phone"
                            placeholder="Phone number"
                          ></b-form-input>
                          <template
                            slot="description"
                            v-if="validation.firstError('phone')"
                          >
                            <span style="color: red">{{
                              validation.firstError("phone")
                            }}</span>
                          </template>
                        </b-form-group>
                      </div>
                    </b-col>
                    <b-col cols="12" md="4" v-if="role == 'CountryAdmin' || role == 'StateAdmin' || role == 'CityAdmin' ">
                      <span class="item_title">Country *</span>
                    </b-col>
                    <b-col cols="12" md="8" v-if="role == 'CountryAdmin' || role == 'StateAdmin' || role == 'CityAdmin' ">
                      
                        <b-form-group label="">
                          <b-form-select
                            v-model="countryselect"
                            :options="countrylist"
                            text-field="country"
                            value-field="country"
                          ></b-form-select>

                         
                        </b-form-group>
                    
                    </b-col>
                    <b-col cols="12" md="4" v-if="role == 'StateAdmin' || role == 'CityAdmin' ">
                      <span class="item_title">State *</span>
                    </b-col>
                    <b-col cols="12" md="8" v-if="role == 'StateAdmin' || role == 'CityAdmin' ">
                      <b-form-group label="">
                        <b-form-select
                          v-model="stateselect"
                          :options="statelist"
                          text-field="state"
                          value-field="state"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="4" v-if="role == 'CityAdmin' ">
                      <span class="item_title">City *</span>
                    </b-col>
                    <b-col cols="12" md="8" v-if="role == 'CityAdmin' ">
                      <b-form-group label="">
                        <b-form-select
                          v-model="cityselect"
                          :options="citylist"
                          text-field="city"
                          value-field="city"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
               

                <b-col cols="12" md="7">
                  <b-row>
                    <b-col cols="12" md="4">
                      <span class="item_title">Role *</span>
                    </b-col>
                    <b-col cols="12" md="8" v-if="userRole == 'Admin' ">
                      <div :class="{ error: validation.hasError('role') }">
                        <b-form-group label="">
                          <b-form-select
                            v-model="role"
                            :options="roles"
                          ></b-form-select>
                          <template
                            slot="description"
                            v-if="validation.firstError('role')"
                          >
                            <span style="color: red">{{
                              validation.firstError("role")
                            }}</span>
                          </template>
                        </b-form-group>
                      </div>
                    </b-col>
                     <b-col cols="12" md="8" v-if="userRole == 'CountryAdmin' ">
                      <div :class="{ error: validation.hasError('role') }">
                        <b-form-group label="">
                          <b-form-select
                            v-model="role"
                            :options="croles"
                          ></b-form-select>
                          <template
                            slot="description"
                            v-if="validation.firstError('role')"
                          >
                            <span style="color: red">{{
                              validation.firstError("role")
                            }}</span>
                          </template>
                        </b-form-group>
                      </div>
                    </b-col>
                     <b-col cols="12" md="8" v-if="userRole == 'StateAdmin' ">
                      <div :class="{ error: validation.hasError('role') }">
                        <b-form-group label="">
                          <b-form-select
                            v-model="role"
                            :options="sroles"
                          ></b-form-select>
                          <template
                            slot="description"
                            v-if="validation.firstError('role')"
                          >
                            <span style="color: red">{{
                              validation.firstError("role")
                            }}</span>
                          </template>
                        </b-form-group>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row v-if="role == 'Admin'">
                    <b-col cols="12" md="12">
                      <b-row class="pt-4">
                        <b-col cols="6">
                          <span class="item_title mt-2">Action</span>
                        </b-col>
                        <b-col cols="6" class="text-right">
                          <span class="item_title">Can Perform</span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="6">
                          <span class="item_value mt-2">Remove Post</span>
                        </b-col>
                        <b-col cols="6" class="text-right">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-1"
                              v-model=" removecase"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="6">
                          <span class="item_value mt-2">Remove Comments</span>
                        </b-col>
                        <b-col cols="6" class="text-right">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-2"
                              v-model="removecomment"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="6">
                          <span class="item_value mt-2">Ban Users</span>
                        </b-col>
                        <b-col cols="6" class="text-right">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-3"
                              v-model="banuser"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="6">
                          <span class="item_value mt-2">Add Lower Admins</span>
                        </b-col>
                        <b-col cols="6" class="text-right">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-4"
                              v-model="addloweradmin"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                     <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="9">
                      <span class="item_value mt-2">Remove Super Admins</span>
                     
                    </b-col>
                    <b-col cols="3" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="removesuperadmin"
                          v-model="removesuperadmin"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>
                    <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="9">
                      <span class="item_value mt-2">Remove Country Admins</span>
                     
                    </b-col>
                    <b-col cols="3" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="removecountryadmin"
                          v-model="removecountryadmin"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>
                 <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="9">
                      <span class="item_value mt-2">Remove State Admins</span>
                     
                    </b-col>
                    <b-col cols="3" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="removestateadmin"
                          v-model="removestateadmin"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>
                 <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="9">
                      <span class="item_value mt-2">Remove City Admins</span>
                     
                    </b-col>
                    <b-col cols="3" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="removecityadmin"
                          v-model="removecityadmin"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>
                    <!-- <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="8">
                          <span class="item_value mt-2"
                            >View activity log of super admins
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-right">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-6"
                              v-model="logspadmin"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col> -->
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="8">
                          <span class="item_value mt-2"
                            >View activity log of lower admins</span
                          >
                        </b-col>
                        <b-col cols="4" class="text-right">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-7"
                              v-model="viewactivitylog"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                     <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="8">
                          <span class="item_value mt-2"
                            >View Pending actions of lower admins</span
                          >
                        </b-col>
                        <b-col cols="4" class="text-right">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-18"
                              v-model="viewpendingaction"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <!-- <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="8">
                          <span class="item_value mt-2"
                            >Revert actions of Country admins</span
                          >
                        </b-col>
                        <b-col cols="4" class="text-right">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-8"
                              v-model="revertcountryadminaction"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="8">
                          <span class="item_value mt-2"
                            >Revert actions of State admins</span
                          >
                        </b-col>
                        <b-col cols="4" class="text-right">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-9"
                              v-model="revertstateadminaction"
                              name="checkbox-1"
                              style="color#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                       <hr />
                    </b-col>
                     <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="8">
                          <span class="item_value mt-2"
                            >Revert actions of City admins</span
                          >
                        </b-col>
                        <b-col cols="4" class="text-right">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-9"
                              v-model="revertcityadminaction"
                              name="checkbox-1"
                              style="color#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                    </b-col> -->
                  </b-row>

                  <b-row v-if="role == 'CountryAdmin'">
                    <b-col cols="12" md="12">
                      <b-row class="pt-4">
                        <b-col cols="4">
                          <span class="item_title mt-2">Action</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">Can Perform</span>
                        </b-col>
                        <b-col cols="4" class="text-right">
                          <span class="item_title" style=" text-align: center;"
                            >Mandatory approval by higher admin</span
                          >
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Remove Post</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="removecase"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="removecase_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Remove Comments</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-2"
                              v-model="removecomment"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="removecomment_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Ban User</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-3"
                              v-model="banuser"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="banuser_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Add State admins</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-4"
                              v-model="addstateadmin"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="addstateadmin_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Add City admins</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-5"
                              v-model="addcityadmin"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="addcityadmin_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>

                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Remove State admin</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-7"
                              v-model="removestateadmin"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="removestateadmin_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>

                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Remove City admin</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-7"
                              v-model="removecityadmin"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="removecityadmin_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2"
                            >View activity log of lower admins</span
                          >
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-8"
                              v-model="viewactivitylog"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title"> </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <!-- <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2"
                            >Revert actions of State admin</span
                          >
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-9"
                              v-model="revertstateadminaction"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="revertstateadminaction_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr/>
                    </b-col>
                     <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2"
                            >Revert actions of City admin</span
                          >
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-9"
                              v-model="revertcityadminaction"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="revertcityadminaction_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                    </b-col> -->
                  </b-row>

                  <b-row v-if="role == 'StateAdmin'">
                    <b-col cols="12" md="12">
                      <b-row class="pt-4">
                        <b-col cols="4">
                          <span class="item_title mt-2">Action</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">Can Perform</span>
                        </b-col>
                        <b-col cols="4" class="text-right">
                          <span class="item_title" style="text-align: center"
                            >Mandatory approval by higher admin</span
                          >
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Remove Post</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="removecase"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="removecase_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Remove Comments</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-2"
                              v-model="removecomment"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="removecomment_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Ban User</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-3"
                              v-model="banuser"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="banuser_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>

                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Add City admins</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-5"
                              v-model="addcityadmin"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="addcityadmin_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>

                    <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="4">
                      <span class="item_value mt-2">Remove City admin</span>
                    </b-col>
                    <b-col cols="4" class="text-center">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-7"
                           
                          v-model="removecityadmin"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                    <b-col cols="4" class="text-center">
                      <span class="item_title">
                        <b-form-checkbox
                          v-model="removecityadmin_approval"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2"
                            >View activity log of lower admins</span
                          >
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-8"
                              v-model="viewactivitylog"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title"> </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                     <!-- <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2"
                            >Revert actions of City admin</span
                          >
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-9"
                              v-model="revertcityadminaction"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="revertcityadminaction_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                    </b-col> -->
                  </b-row>

                  <b-row v-if="role == 'CityAdmin'">
                    <b-col cols="12" md="12">
                      <b-row class="pt-4">
                        <b-col cols="4">
                          <span class="item_title mt-2">Action</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">Can Perform</span>
                        </b-col>
                        <b-col cols="4" class="text-right">
                          <span class="item_title" style="text-align: center"
                            >Mandatory approval by higher admin</span
                          >
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Remove Post</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="removecase"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="removecase_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Remove Comments</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-2"
                              v-model="removecomment"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="removecomment_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Ban User</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-3"
                              v-model="banuser"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="banuser_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>

                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="4">
                          <span class="item_value mt-2">Warn User</span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              id="checkbox-5"
                              v-model="warnuser"
                              name="checkbox-1"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                        <b-col cols="4" class="text-center">
                          <span class="item_title">
                            <b-form-checkbox
                              v-model="warnuser_approval"
                              color="#2BA09F"
                            ></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="py-2 justify-content-md-center">
            <span style="color: red">{{ msg }}</span>
          </b-row>

          <template slot="footer">
            <b-row class="justify-content-center">
              <div class="px-2">
                <b-button
                  variant="primary"
                  size="sm"
                  @click.prevent="inputCheck"
                  >Send Invite</b-button
                >
              </div>
            </b-row>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>

export default {
  props:["adrole"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      msg: null,

      email: null,
      username: null,
      password: null,
      phonePrefix: null,
      phone: null,
      role: null,
      removesuperadmin: true,
      removecountryadmin: true,
      removestateadmin: true,
      removecityadmin: true,
      removecountryadmin_approval:false,
      removestateadmin_approval:false,
      removecityadmin_approval:false,
      removecase: true,
      removecomment: true,
      banuser: true,
      addsuperadmin: true,
      addcountryadmin: true,
      addstateadmin: true,
      addcityadmin: true,

      addloweradmin: true,
      viewactivitylog: true,
      viewpendingaction: true,
      revertcountryadminaction: false,
      revertstateadminaction: false,
      revertcityadminaction: false,
      warnuser: true,
      removecase_approval: false,
      removecomment_approval: false,
      banuser_approval: false,
      addsuperadmin_approval: false,
      addcountryadmin_approval: false,
      addstateadmin_approval: false,
      addcityadmin_approval: false,
      viewactivitylog_approval: false,
      viewpendingaction_approval: false,
      revertcountryadminaction_approval: false,
      revertstateadminaction_approval: false,
      revertcityadminaction_approval: false,
      warnuser_approval: false,
      removecountryadmin: true,
      logspadmin: false,
      logladmin: false,
      revertstadmin: false,
      revertcadmin: false,

      userRole: localStorage.getItem("role"),
      roles: [
        { text: "Super Admin", value: "Admin" },
        { text: "Country Admin", value: "CountryAdmin" },
        { text: "State Admin", value: "StateAdmin" },
        { text: "City Admin", value: "CityAdmin" },
      ],
      croles: [
       
        { text: "State Admin", value: "StateAdmin" },
        { text: "City Admin", value: "CityAdmin" },
      ],
      sroles: [
        
        { text: "City Admin", value: "CityAdmin" },
      ],
      
      countryselect: null,
      stateselect: null,
      cityselect: null,
      countrylist: [],
      statelist: [],
      citylist: [],
      userRole: localStorage.getItem("role"),
    };
  },

  validators: {
    email(value) {
      return this.Validator.value(value).required("Required Field").email();
    },
    phonePrefix(value) {
      return this.Validator.value(value).required("Required Field");
    },
    phone(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[0-9]{10}$", "Please Input Valid Number.");
    },
    password(value) {
      return this.Validator.value(value).required("Required Field");
    },
    username(value) {
      return this.Validator.value(value).required("Required Field");
    },
    role(value) {
      return this.Validator.value(value).required("Required Field");
    },
   
  },

  mounted() {
    this.role = this.adrole;
    this.getcountry();
  },
  watch: {
    countryselect() {
      this.statelist = [];
      this.citylist = [];
      this.getState();
    },
    stateselect() {
      this.getCity();
    },
  },
  methods: {
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          var user = response.data.data;
          this.division = user.division._id;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    inputCheck() {
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.addUser();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },
    addUser() {
      this.appLoading = true;
      var user = {};
      user["username"] = this.username;
      user["phonePrefix"] = this.phonePrefix;
      user["phone"] = this.phone;
      user["email"] = this.email;
      user["password"] = this.password;
      user["country"] = this.countryselect;
      user["state"] = this.stateselect;
      user["city"] = this.cityselect;
      user["type"] = this.role;
      user["removecase"] = this. removecase;
      user["removecase_approval"] = this.removecase_approval;
      user["removecomment"] = this.removecomment;
      user["removecomment_approval"] = this.removecomment_approval;
      user["banuser"] = this.banuser;
      user["banuser_approval"] = this.banuser_approval;
      user["viewactivitylog"] = this.viewactivitylog;
      user["viewpendingaction"]=this.viewpendingaction;
      user["addloweradmin"]=this.addloweradmin;
      user["addstateadmin"] = this.addstateadmin;
      user["addstateadmin_approval"] = this.addstateadmin_approval;
      user["addcityadmin"] = this.addcityadmin;
      user["addcityadmin_approval"] = this.addcityadmin_approval;
      user["removecityadmin"] = this.removecityadmin;
       user["removestateadmin"] = this.removestateadmin;
      user["removecountryadmin_approval"] = this.removecountryadmin_approval;
      user["removestateadmin_approval"] = this.removestateadmin_approval;
      user["removecityadmin_approval"] = this.removecityadmin_approval;
      user["revertcountryadminaction"] = this.revertcadmin;
      user["revertstateadminaction"] = this.revertstateadminaction;
      
      user["revertstateadminaction_approval"] = this.revertstateadminaction_approval;
      user["revertcityadminaction"] = this.revertcityadminaction;
      user["revertcityadminaction_approval"] = this.revertcityadminaction_approval;
      user["warnuser"] = this.warnuser;
      user["warnuser_approval"] = this.warnuser_approval;
      var newURL = "/user/CreateAdmin";

      axios({
        method: "POST",
        url: newURL,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.go(-1);
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    getcountry() {
      this.appLoading = true;

      axios({
        method: "GET",
        url: "/country/getlistnew",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.countrylist = response.data.data;
          // this.getState();
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },

    getState(item) {
      this.appLoading = true;

      axios({
        method: "GET",
        url: "/state/getlistnewbyname",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          country: this.countryselect,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.statelist = response.data.data;
          // this.getCity();
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    getCity(item) {
      this.appLoading = true;

      axios({
        method: "GET",
        url: "/city/getlistnewbyname",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          state: this.stateselect,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.citylist = response.data.data;
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
  },
};
</script>
